module.exports = __webpack_public_path__ + "static/media/tutorial_multiple.937a4d89.jpg";